var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('div',{staticStyle:{"padding":"32px"}},[(_vm.$account)?_c('BookingWidget',{attrs:{"is-personal":"","user":_vm.user}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }